import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Bold } from '@sorare/core/src/atoms/typography/Bold';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { useTimeLeft } from '@sorare/core/src/hooks/useTimeLeft';

const EmptyMessage = styled(Vertical).attrs({ center: true, gap: 2 })`
  flex: 1;
`;

export const NoGameState = ({
  tasksExpiresAt,
}: {
  tasksExpiresAt: Date | null;
}) => {
  const { formatDate } = useIntlContext();
  const { message } = useTimeLeft(tasksExpiresAt);
  return (
    <EmptyMessage>
      <BodyM className="text-center" color="var(--c-nd-600)">
        <FormattedMessage defaultMessage="You have no cards playing today" />
      </BodyM>
      {!!tasksExpiresAt && (
        <BodyM className="text-center" color="var(--c-nd-600)">
          <FormattedMessage
            defaultMessage="Daily Missions refresh in <strong>{timeLeft} ({dateValue})</strong>. Check back soon for your next challenge!"
            values={{
              timeLeft: message,
              strong: Bold,
              dateValue: formatDate(tasksExpiresAt, {
                hour: '2-digit',
                minute: '2-digit',
              }),
            }}
          />
        </BodyM>
      )}
    </EmptyMessage>
  );
};
